import PostShow from '../components/post/Show.vue';
import PostList from '../components/post/List.vue';

export default [
    {
        name: 'PostShow',
        path: '/posts/show/:id',
        component: PostShow,
        meta: {
            title: 'index.title'
        }
    },
    {
        name: 'PostList',
        path: '/',
        component: PostList,
        meta: {
            title: 'index.title'
        }
    }
];



// WEBPACK FOOTER //
// ./src/routes/post.js